import React, { useEffect } from "react";
import Box from "@mui/material/Box";
import Breadcrumb from "../../common/header/Breadcrumb";
import Header from "../../common/header/Header";
import PaymentReminderTemplate from "../../components/NotificationSettings/PaymentReminderTemplate";

const PaymentReminder = () => {
   useEffect(() => {
            window.scrollTo(0, 0);
        }, []);
  return (
    <>
    <Box sx={{ flexGrow: 1 }} className="page-background">
      <Header />
      <Breadcrumb />
      <PaymentReminderTemplate/>
    </Box>
  </>
  )
}

export default PaymentReminder